export default {
  'Application': {
    'title': 'Swizi',
    'addApp': 'Ajoutez une app',
    'showSubscriptionAfterLogin': "Afficher l'écran d'inscription (centre d'intéret) au premier login",
    'cancel': 'Annuler',
    'available': 'disponible',
    'MoAvailable': 'utilisés (maximum recommandé)',
    'LOADING': 'Chargement en cours',
    'ERROR': 'Une erreur est survenue. Veuillez réessayer plus tard.',
    'LOADED': ' ',
    'name': 'Nom',
    'version': 'Version',
    'mapWizeApiKey': 'MapWize API key',
    'mapWizeAccessKey': 'MapWize Access key',
    'date_publication': 'Date de publication souhaitée',
    'type_publication': 'Type de publication',
    'select_type_publication': 'Sélectionner le type de publication',
    'langs': 'Langues disponibles',
    'select_langs': 'Sélectionner les langues disponibles',
    'default_lang': 'Langue par défaut',
    'select_default_lang': 'Sélectionner la langue par défault',
    'owner': 'Propriétaire',
    'select_owner': 'Sélectionner le propriétaire',
    'stores': {
      'android': 'Publier sur Play Store',
      'ios': 'Publier sur App Store',
      'error': 'Un store est requis',
    },
    'list': {
      'createApp': 'Créer une application',
      'updateApp': 'Modifier l\' application',
    },
    'duplicate': 'Dupliquer cette application',
    'new_version': 'Créer une nouvelle version',
    'edit': 'Modifier cette version de l\'application',
    'delete': 'Supprimer cette version de l\'application',
    'searchPlaceholder': 'Rechercher...',
    'searchUserPlaceholder': 'Rechercher un utilisateur...',
    'missingFunctionnality': 'Cette fonctionnalité n\'est pas encore disponible. ' +
      'Revenez plus tard pour la voir en action.',
    'disableFeature': 'Vous n\'avez pas accès à cette fonctionnalité',
    'copy': 'Copie d\' une application existante',
    'copyFromApp': 'Application à copier',
    'copyOwner': 'Propriétaire de l\'application à copier',
    'select_app': 'Sélectionner l\'application à copier',
    'playerOnly': 'Vous avez un rôle Bêta testeur. Vous pouvez uniquement accéder aux applications ' +
      'des équipes dont vous êtes membre.',
    'NotAvailableFeature': 'Cette fonctionnalité n\'est pas disponible dans votre offre. ' +
      'Veuillez contacter l\'équipe commerciale pour disposer de la fonctionnalité.',
  },
  'Login': {
    'username': 'Nom d\'utilisateur',
    'firstname': 'Prénom',
    'lastname': 'Nom',
    'email': 'Adresse e-mail',
    'password': 'Mot de passe',
    'confirmPassword': 'Confirmation du mot de passe',
    'connect': 'Se connecter',
    'register': 'S\'enregistrer',
    'forgot': 'J\'ai oublié',
    'required': 'Champs requis',
  },
  'Header': {
    'search': 'Rechercher...',
    'appViewer': 'Le Player',
    'ios': 'Le Player iOS',
    'android': 'Le Player Android',
    'account': 'Mon compte',
    'team': 'Équipe',
    'settings': 'Paramètres',
    'logout': 'Déconnexion',
    'myApps': 'Mes apps',
    'admin': 'Administration',
  },
  'Menu': {
    'build': 'Construction',
    'distribute': 'Distribution',
    'animate': 'Animation',
    'measure': 'Mesures',
    'users': 'Utilisateurs',
    'usersGroups': 'Utilisateurs & groupes',
    'navigation': 'Style de menus',
    'library': 'Bibliothèque',
    'design': 'Design',
    'contents': 'Contenus',
    'dashboard': 'Tableau de bord',
    'datasources': 'Connecteurs',
    'deployment': 'Déploiement',
    'api': 'API',
    'cgu': 'CGU',
    'privacyPolicy': 'Protection des données',
    'notification': 'Notifications',
    'notificationInfo': 'Suivi de notifications',
    'notificationHistory': 'Historique des notifications',
    'news': 'News',
    'quiz': 'Quizz',
    'question': 'Questions au speaker',
    'analytics': 'Analytics',
    'segmentation': 'Segmentation',
    'behaviour': 'Données comportementales',
    'entries': 'Sections',
    'userEntries': 'Sections utilisateur',
    'pages': 'Popups',
    'page': 'Popups',
    'addentries': 'Ajouter une section',
    'adduserEntries': 'Ajouter une section utilisateur',
    'addpage': 'Ajouter une popup',
    'version': 'Version',
    'sectionIsHomePublic': 'Cette section est la page d\'accueil',
    'sectionIsHomePrivate': 'Cette section est la page d\'accueil' +
      'd\'un utilisateur connecté du/des groupe(s) suivant: ',
    'sectionIsPrivate': 'Cette section est limitée au(x) groupe(s) suivant: ',
    'filters': 'Filtres',
    'reorganize': 'Réorganiser l\'ordre des sections',
  },
  'NavigationTypeMenu': {
    'title': 'Type de navigation',
    'generalTitle': 'Général',
    'generalPres': 'Présentation',
    'presentation_title': 'Choisissez le type de style de menus',
    'selectNavigation': 'Mode de navigation',
    'configuration': 'Configuration',
    'SIDE_MENU': 'Menu latéral',
    'SIDE_MENU_ICON': 'Menu latéral (icones)',
    'SHAPE_MENU_ICON': 'Menu latéral (shape)',
    'TWO_COLS_TILES_SIDE_MENU': 'Menu latéral (tuiles)',
    'TAB_BAR_NAVIGATION': 'Menu Tabbar',
    'close': 'Pas de forme',
    'fabConfiguration': 'Configuration du FAB',
    'tabbarConfiguration': {
      'title': 'Configuration de la tab bar',
      'showTitle': 'Afficher le titre',
      'showSelectedIndicator': 'Afficher l\'indicateur de sélection',
      'showCentralButton': 'Afficher le bouton central',
    },
  },
  'Library': {
    'title': 'Bibliothèque',
    'upload': 'Envoyer un fichier',
    'download': 'Télécharger le fichier',
    'uploadMediasZip': 'Envoyer des fichiers sous format ZIP',
    'downloadAllMediasZip': 'Télécharger les fichiers sous format ZIP',
    'useFile': 'Utiliser un fichier zip',
    'sendFile': 'Envoyer ce fichier zip',
    'missingFile': 'Fichier manquant : ',
    'uploadVideo': 'Envoyer une vidéo',
    'uploadPic': 'Envoyer une image',
    'noDelete': 'Ce média est utilisé. Il ne peut pas être supprimé.',
    'tagPlaceHolder': 'Filter par tags',
    'noTagsFound': 'Aucun tag trouvé',
    'placeholderImgTags': 'Sélectionner ou créer un tag',
    'handleTags': 'Gérer les tags du média',
    'selectIconCategory': 'Choisissez une catégorie d\'icônes',
    'libraryImages': 'Bibiothèque d\'images',
    'replace': 'Remplacer ce média',
  },
  'Error': {
    '404': 'Oups, cela n\'existe pas',
    'validEmail': 'Veuillez vérifier votre adresse e-mail',
    'confirmPassword': 'Le mot de passe n\'est pas identique',
    'passwordSecurity': 'Requiert au moins 8 caractères, une majuscule, une minuscule, un ' +
      'nombre et un caractère spécial (?+.-/!$) ',
    'required': 'Champs requis',
    'Croutons': {
      'internalError': 'Une erreur interne est survenue',
      'waiting': 'Veuillez patienter',
      'authSuccess': 'Connexion réussie',
      'authFail': 'Erreur de connexion',
      'authExpired': 'Merci de vous ré-authentifier',
      'saveSuccess': 'L\'enregistrement a réussi',
      'saveError': 'L\'enregistrement a échoué, vérifiez les données, ou réessayez plus tard',
      'saveErrorAction': 'Les actions des boutons sont nécessaires. Veuillez en ajouter.',
      'deleteSuccess': 'La suppression a réussi',
      'deleteError': 'La suppression a échoué, vérifiez les données, ou réessayez plus tard',
      'uploadSuccess': 'Le fichier a été envoyé avec succès',
      'downloadSuccess': 'Les fichiers ont bien été exportés',
      'uploadFail': 'L\'envoi de fichier a échoué, réessayez plus tard',
      'uploadConfigInvalid': 'Le fichier manifest.json du plugin est invalide',
      'saveErrorUser': 'Merci de vérifier les données de l\'utilisateur',
      'userWSAlreadyExists': 'Le login est déjà utilisé',
      'groupAlreadyExists': 'Le nom du groupe est déjà utilisé',
      'saveErrorApiKey': 'Merci de vérifier les données de la clé d\'api',
      'saveErrorPOI': 'Merci de vérifier les données du POI',
      'saveErrorContact': 'Merci de vérifier les données du contact',
      'reinitPassword': 'Un email vient de vous être envoyé pour réinitialiser votre mot de passe',
      'missingHelp': 'L\'aide n\'est pas disponible pour le moment',
      'missingName': 'Le nom est obligatoire',
      'missingType': 'Le type d\'action est obligatoire',
      'duplicateName': 'Le nom est déjà utilisé',
      'pushSuccess': 'Notification envoyée avec succès',
      'pushError': 'Erreur lors de l\'envoi de la notification',
      'changePasswordFailed': 'Erreur lors du changement de mot passe ' +
        ': le code de réinitialisation a expiré ou est invalide.',
      'apiKeyIncorrect': 'Merci de vérifier vos clés d\'authentification',
      'subscribeDMError': 'L\'abonnement au service de Data Mediation a échoué. ' +
        'Merci de vérifier la configuration du service.',
      'subscribeGenericError': 'L\'abonnement au service a échoué. ' +
        'Merci de vérifier la configuration du service.',
      'subscribeFormError': 'L\'abonnement au service de stockage a échoué. ' +
        'Merci de vérifier la configuration du gestionnaire de stockage.',
      'subscribeResourceManagerError': 'L\'abonnement au service de ressources a échoué. ' +
        'Merci de vérifier la configuration du gestionnaire de ressources.',
      'subscribePlannerError': 'L\'abonnement au service planning a échoué. ' +
        'Merci de vérifier la configuration du planning.',
      'updatePlannerConfigError': 'La modification de la configuration du service planning a échoué. ' +
        'Merci de vérifier la configuration du planning.',
      'subscribeCheckinError': 'L\'abonnement au service checkin a échoué. ' +
        'Merci de vérifier la configuration du checkin.',
      'updateCheckinConfigError': 'La modification de la configuration du service checkin a échoué. ' +
        'Merci de vérifier la configuration du checkin.',
      'chatConfigError': 'Une erreur liée au serveur de messagerie instantanée est survenue. ' +
        'Merci de vérifier la configuration de la messagerie instantanée.',
      'errorLoadingData': 'Erreur de chargement de données',
      'syncSuccess': 'La synchronisation a réussi',
      'deleteUsedGroup': 'Suppression impossible : le groupe est utilisé en tant que parent',
    },
    'userToAddFirstname': 'Prénom invalide',
    'userToAddLastname': 'Nom de famille invalide',
    'userToAddEmail': 'Email invalide',
    'userToAddLogin': 'Login invalide',
    'userToAddLongEmailPhone': 'Le login et l\'email ou le login et le téléphone sont obligatoires',
    'userToAddPassword': 'Mot de passe invalide',
    'userToAddCPassword': 'Le mot de passe et sa confirmation sont différents',
    'beaconName': 'Nom invalide',
    'beaconMacAddress': 'Adresse mac invalide',
  },
  'AppBar': {
    'delete': 'Supprimer',
    'save': 'Enregistrer',
    'undo': 'Annuler',
    'edit': 'Configurer',
  },
  'Welcome': {
    'item_library': 'Bibliothèque',
    'item_design': 'Design',
    'item_users': 'Utilisateurs',
    'item_iot': 'Connecteurs',
    'item_content': 'Contenu',
    'item_navigation': 'Style de menus',
    'item_library_desc': 'Je gère les contenus image, vidéos et son de mon application',
    'item_design_desc': 'Je choisis le style de mon application en choisissant son icone,' +
      ' son splashscreen et ses couleurs.',
    'item_users_desc': 'Je gère les utilisateurs et les groupes de mon application pour' +
      ' proposer une expérience utilisateur différente selon les profils',
    'item_iot_desc': 'Je créé des POIs Google Maps, beacons. Je paramêtre des données, ' +
      'je personnalise des vues, j\'envoi des fichiers pour les utilisateurs... ' +
      'Je gère toutes mes données pour l\'application.',
    'item_iot_desc2': 'Je configure des beacons. J\'associe des notifications, des sections, des pop-up ou des liens ' +
      'externes pour créer de l\'interaction lorsque mes utilisateurs approchent des beacons',
    'item_content_desc': 'Je construis les différentes sections de mon application, ' +
      'je gère les contenus de ces sections, j\'anime mon application en déclenchant des notifications, ' +
      'j\'affecte des droits aux utilisateurs.',
    'item_navigation_desc': 'Je choisis le style de menus de mon application',
  },
  'STATUS': {
    'CONSTRUCTION': 'En construction',
    'PUBLICATION_IN_PROGRESS': 'Publication en cours',
    'PUBLICATION_ONLINE': 'Disponible sur le store',
    'PACKAGING_IN_PROGRESS': 'Packaging en cours',
    'PACKAGING_DONE': 'Packaging fini',
    'ARCHIVED': 'Archivé',
  },
  'STORE_STATUS': {
    'NOT_PUBLISH': 'Non publiée',
    'PUBLISHING': 'En cours de publication',
    'FAILED': 'Refusé',
    'PUBLISHED': 'Disponible sur le store',
  },
  'date': {
    'short': 'DD/MM/YY',
    'long': 'DD/MM/YYYY HH:mm',
    'hour': 'HH:mm:ss',
  },
  'SortType': {
    'POSITION': 'Par position',
    'DATE': 'Date publication -> Date création',
    'PUBLICATION': 'Date de publication',
    'MODIFICATION': 'Date de modification',
    "CREATION": "Date de création"
  },
  'ContentTypes': {
    'FILL': 'Etiré pour remplir la zone d\'affichage',
    'FIT': 'Contraindre à la zone d\'affichage',
    'CENTER': 'Aucune (image affichée aux dimensions telle quelle)',
    'QUIZZ': 'Quizz',
    'PLAN': 'Image interactive',
    'AGENDA': 'Agenda',
    'SOCIAL': 'Réseau social',
    'GALLERY': 'Galerie',
    'PHOTOS': 'Photos',
    'GENERICS': 'Générique',
    'GENERICS_LIST': 'Liste générique',
    'NEWS': 'News',
    'DASHBOARD': 'Navigation',
    'INFOS': 'Informations',
    'MAP': 'Carte Google Maps',
    'CALLING_CARD': 'Carte de visite',
    'PASS_QRCODE': 'QRCode pass',
    'MULTIPLE_CHOICE': 'Choix multiple',
    'RA': 'Réalité augmentée',
    'GEOLOC': 'Géolocalisation des utilisateurs',
    'CATALOG': 'Catalogue',
    'RSS': 'Flux RSS',
    'CHAT': 'Messagerie instantanée',
    'RESOURCE_MANAGER': 'Gestionnaire de resource',
    'ON_BOARDING': 'On Boarding',
    'FORM': 'Formulaire',
    'DM': 'Data Mediation',
    'PLANNER': 'Swizi Planner',
    'PLUGIN': 'Plugin',
    'ANNUAIRE': 'Annuaire',
    'MAPWIZE': 'Carte Mapwize',
    'BUSINESS_CARD': 'Carte de visite',
    'PHOTO_WALL': 'Mur de photos',
    'SELFIE': 'Selfie',
  },
  'Content': {
    'conservePlugin': 'Conserver la configuration du manifeste',
    'icon': 'Icône',
    'picture': 'Image',
    'group': 'Groupe',
    'noCategories': 'Créez, ajoutez des catégories aux sections, pour ainsi facilement vous y retrouver',
    'addAction': 'Ajouter une action',
    'actionList': 'Liste des actions',
    'sectionHeader': 'Entête de la section',
    'sectionBackground': 'Arrière plan de la section',
    'name': 'Titre',
    'name0': 'Titre',
    'name1': 'Nom de la catégorie',
    'name2': 'Alias de la Venue',
    'name3': 'Nom du dossier',
    'name5': 'Nom du groupe',
    'description': 'Sous-titre',
    'fontSize': 'Taille de la police d\'écriture',
    'url': 'Lien web externe',
    'navBarTitle': 'Titre dans la barre de navigation',
    'entryType': 'Type de contenu',
    'entryTags': 'Catégories',
    'analyticsEntryTags': 'Tags Analytics',
    'placeholderSectionTags': 'Sélectionnez ou créez une catégorie',
    'TagsViewTitle': 'Sections par catégories',
    'TagsViewOpen': 'Ouvrir la vue par catégories',
    'publicAccess': 'Accès public (authentification non nécessaire)',
    'inMenu': 'Section visible dans le menu',
    'fullscreen': 'Section affichée en plein écran',
    'prefersLargeTiles': 'Préférence titre large',
    'defaultZoom': 'Zoom par défaut sur l\'utilisateur',
    'sortDesc': 'Liste triée par ordre croissant',
    'showTrendings': 'Afficher à la une',
    'sortField': 'Critère de tri',
    'defaultZoomMapwize': "Zoom par défaut de la carte Mapwize",
    'searchableActive': 'Recherche dans la liste activée',
    'saveSuccess': 'Contenu sauvegardé',
    'saving': 'Contenu en cours d\'enregistrement',
    'saveError': 'Erreur lors de l\'enregistrement',
    'sectionContentsTitle': 'Rubriques',
    'addContentPlaceholder': 'Ajouter un contenu',
    'addMask': 'Ajouter un masque',
    'urlYoutube': 'Lien web de votre vidéo youtube',
    'mapWizeApiKey': 'MapWize API',
    'mapWizeVenueId': 'Venue Alias',
    'types': {
      'IMAGE': 'Image',
      'VIDEO': 'Vidéo',
      'HTML': 'Html',
      'URL': 'URL',
    },
    'notifyUsers': 'Notifier les utilsateurs d\'un changement de contenu',
    'programVisibility': 'Programmer la visibilité d\'un contenu',
    'delete': 'Supprimer le contenu',
    'add': 'Ajouter le contenu',
    'save': 'Sauvegarder le contenu',
    'cancel': 'Annuler les modifications',
    'edit': 'Modifier le contenu',
    'notify': 'Envoyer une notification du changement de contenu immédiatement',
    'duplicate': 'Dupliquer le contenu',
    'configureSection': 'Configurer la sélection',
    'configureSectionColors': 'Surcharger les couleurs de la section',
    'actionName1': 'Nom de la première action',
    'actionName2': 'Nom de la seconde action',
    'action1': 'Gestion de la première action',
    'action2': 'Gestion de la seconde action',
    'editAction': 'Editer l\'action',
    'editAction1': 'Editer la première action',
    'editAction2': 'Editer la deuxième action',
    'markerName': 'Nom',
    'markerActive': 'Actif',
    'markerUserMedia': 'Utiliser une vidéo',
    'sendInCsv': 'Envoyer par fichier Csv',
    'poiDownloadAllInCsv': 'Télécharger les vôtres en Csv',
    'poiDownloadCsvExample': 'Télécharger un exemple en Csv',
    'zipFileList': 'Liste des fichiers présents dans le zip',
    'zipFileName': 'Cette section dispose du plugin',
    'noZipFile': 'Cette section ne dispose pas encore de plugin',
    'pluginVendor': 'Fournisseur: ',
    'pluginExample': 'Télécharger un exemple de manifeste',
    'pluginDemoExample': 'Télécharger un plugin démo',
    'pluginVersion': 'Version: ',
    'pluginDescription': 'Description',
    'pluginConfig': 'Configuration',
    'pluginRequirements': 'Pré-requis',
    'pluginApiKey': 'Api key',
    'pluginApiKeyScopes': 'Droits : ',
    'pluginWhatsNew': 'Nouveautés de la version ',
    'pluginApiKeyAuth': 'Authentification : requise',
    'pluginApiKeyNoAuth': 'Authentification : non requise',
    'pluginRequirementsPrivate': 'Ce plugin nécéssite un mode de participation privé',
    'pluginRequirementsMixed': 'Ce plugin nécéssite un mode de participation mixte',
    'pluginSelect': 'Sélectionner un fichier',
    'pluginUpdate': 'Mettre a jour le plugin',
    'pluginUpload': 'Envoyer un fichier Zip',
    'pluginUploadFiles': 'Fichiers du Zip',
    'pluginUploadManifest': 'Manifeste',
    'pluginUploadInvalidManifest': 'Le JSON du fichier manifeste est invalide',
    'pluginUploadErrors': 'Erreurs',
    'noManifestFile': 'Ce plugin ne possède pas de manifeste',
    'pluginManifestAdvantageTitle': 'Le manifeste permet de :',
    'pluginManifestAdvantages1': 'Modifier des variables déclarées dans le manifeste, directement depuis le studio',
    'pluginManifestAdvantages2': 'Récupérer ces variables dans votre plugin grâce aux SDK swizi.js',
    'pluginManifestAdvantages3': 'Gérer les droits d\'accès au plugin et la portée de votre clé API Swizi',
    'placeholderName': 'Nom du contact',
    'placeholderNumber': 'Numéro de téléphone du contact',
    'addContact': 'Ajouter un contact',
    'deleteContact': 'Supprimer un contact',
    'addGroup': 'Ajouter un groupe d\'utilisateurs',
    'deleteGroupe': 'Supprimer un groupe',
    'placeholderRoomName': 'Nom du channel',
    'placeholderRoomDesc': 'Description du channel',
    'listChatRoom': 'Configuration des channels',
    'addChatRoom': 'Ajouter un channel',
    'chatGroup': 'Groupes pour ce channel',
    'chatTags': 'Tags pour ce channel',
    'deleteChatRoom': 'Supprimer un channel',
    'errorChatRoom': 'Erreur chargement information',
    'contentSettings': {
      'publicationSetting': 'Publication',
      'itemColorSetting': 'Contenu',
      'titleColorSetting': 'Titre',
      'notificationSetting': 'Notification',
    },
    'groupVisibility': 'Limiter la visibilité à un groupe',
    'slideshowNotClickable': 'Slideshow non clickable',
    'selfieActive': 'Activer le selfie',
    'enableConversation': 'Autoriser la création de nouvelles conversations',
    'limitUserGroups': 'Afficher uniquement les groupes de l\'utilisateur',
    'useQRCodeLocation': 'Activer la localisation par QR Code',
    'showAllFloorsList': 'Afficher la liste de tout les étages',
    'pluginSource': 'Code source: ',
  },
  'Catalog': {
    'title': 'Catalogue',
  },
  'Alert': {
    'unsavedContent': 'Changements effectués non sauvegardés',
    'save': 'Enregistrer',
    'comfirm': 'Confirmer',
    'cancel': 'Annuler',
    'close': 'Fermer',
    'confirmNotifyTitle': 'Envoi de notification',
    'confirmNotify': 'Êtes-vous sûr(e) de vouloir envoyer une notification ?',
    'confirmDeleteTitle': 'Suppression de contenu',
    'confirmChangeParticipationTitle': 'Changement du mode de participation',
    'confirmChangeParticipationContent': 'La création de cette section va passer ' +
      'l\'application en mode de participation mixte. Voulez-vous continuer ?',
    'confirmDeleteContent': 'Êtes-vous sûr(e) de vouloir supprimer ce contenu ?',
    'confirmDeleteSection': 'Êtes-vous sûr(e) de vouloir supprimer cette section ?',
    'confirmDeletePage': 'Êtes-vous sûr(e) de vouloir supprimer cette page ?',
    'confirmDeleteAction': 'Êtes-vous sûr(e) de vouloir supprimer cette action ?',
    'beaconDeleteTitle': 'Suppression de l\'équipement',
    'beaconDeleteMessage': 'Êtes-vous sûr(e) de vouloir supprimer cet équipement de localisation ?',
    'actionDeleteTitle': 'Suppression d\'action',
    'actionDeleteMessage': 'Êtes-vous sûr(e) de vouloir supprimer cette action ?',
    'poiDeleteTitle': 'Suppression d\'un POI',
    'poiDeleteMessage': 'Êtes-vous sûr(e) de vouloir supprimer ce POI ?',
    'poiTypeDeleteTitle': 'Suppression d\'une catégorie',
    'poiTypeDeleteMessage': 'Êtes-vous sûr(e) de vouloir supprimer cette de catégorie de POI Google MAP ?',
    'MapWizeTypeDeleteMessage': 'Êtes-vous sûr(e) de vouloir supprimer cette de Venue ?',
    'KeyValueTypeDeleteMessage': 'Êtes-vous sûr(e) de vouloir supprimer ce groupe de données ?',
    'APIKeyValueTypeDeleteMessage': 'Êtes-vous sûr(e) de vouloir supprimer ce groupe de données API ?',
    'folderDeleteMessage': 'Êtes-vous sûr(e) de vouloir supprimer ce dossier ?',
    'contactDeleteTitle': 'Suppression d\'un contact',
    'contactDeleteMessage': 'Êtes-vous sûr(e) de vouloir supprimer ce contact ?',
    'roomDeleteTitle': 'Suppression d\'un channel',
    'roomDeleteMessage': 'Êtes-vous sûr(e) de vouloir supprimer ce channel ?',
    'zoomTitle': 'Zoom détecté',
    'zoomMessage': 'Un zoom a été détecté. Merci d\'afficher la page avec un zoom à 100% pour plus de facilité',
    'dupAppTitle': 'Nouvelle version',
    'removeMemberTitle': 'Suppression d\'un membre',
    'removeMemberMessage': 'Êtes-vous sûr(e) de vouloir supprimer ce membre de l\'équipe ?',
    'removeUserTitle': 'Suppression d\'utilisateur',
    'removeUserMessage': 'Êtes-vous sûr(e) de vouloir supprimer cet utilisateur ?',
    'removeUserNameMessage': 'Êtes-vous sûr(e) de vouloir supprimer l\'utilisateur ',
    'removeGroupTitle': 'Suppression d\'un groupe',
    'removeGroupMessage': 'Êtes-vous sûr(e) de vouloir supprimer ce groupe ?',
    'tagDeleteTitle': 'Suppression d\'un tag',
    'tagDeleteMessage': 'Êtes-vous sûr(e) de vouloir supprimer ce tag ?',
    'deleteAppTitle': 'Suppression d\'une version d\'application',
    'deleteAppMessage': 'Êtes-vous sûr(e) de vouloir supprimer cette version d\'application ?',
    'removeProfilTitle': 'Suppression d\'un profil',
    'removeProfilMessage': 'Êtes-vous sûr(e) de vouloir supprimer ce profil ?',
    'ldapTestTitle': 'Test de connexion',
    'azureTestMalformed': 'Le JSON de configuration de Azure AD est mal formé',
    'ldapTestSuccessMessage': 'Le test de connexion à l\'annuaire LDAP a réussi.',
    'ldapTestFailureMessage': 'Le test de connexion à l\'annuaire LDAP a échoué.',
    'authWSConfigInvalid': 'Le JSON d\'authentification par web service est invalide',
    'smsSenderIdInvalid': 'Seuls les caractères alphanumériques sans accents sont acceptés',
    'deloyErrorTitle': 'Données de déploiement',
    'deployMessage': 'Merci de vérifier les données nécessaire pour le déploiement.',
    'notifErrorTitle': 'Envoi de notifications',
    'notifMessage': 'Êtes-vous sûr(e) de vouloir envoyer cette notification ?',
    'deleteMediaTitle': 'Suppression d\'un élément de la bibliothèque',
    'deleteMediaMessage': 'Êtes-vous sûr(e) de vouloir supprimer cet élément de la bibiothèque ?',
    'sizeAlertTitle': 'Taille du fichier',
    'sizeReplaceTitle': 'Remplacement d\'un élément de la bibliothèque',
    'sizeAlertMessage': 'Le fichier est trop lourd. La taille maximale autorisée est de 2 Mo.',
    'sizeReplaceMessage': 'Êtes-vous sur de vouloir remplacer ce media ? L\'ancien sera supprimé.',
    'removeApiKeyTitle': 'Suppression d\'une clé d\'api',
    'removeApiKeyMessage': 'Êtes-vous sûr(e) de vouloir supprimer cette clé d\'api ?',
    'removeNotifTitle': 'Suppression d\'une notification',
    'removeNotifMessage': 'Êtes-vous sûr(e) de vouloir supprimer cette notification ?',
    'removeFileTitle': 'Suppression d\'un fichier',
    'removeFileMessage': 'Êtes-vous sûr(e) de vouloir supprimer ce fichier ?',
    'removeKeyValueTitle': 'Suppression d\'une clé valeur',
    'removeKeyValueMessage': 'Êtes-vous sûr(e) de vouloir supprimer cette clé valeur ?',
    'removeAppTitle': 'Suppression d\'une application',
    'removeAppMessage': 'Êtes-vous sûr(e) de vouloir supprimer définitivement cette application ?',
    'addTeamAndAppTitle': 'Accès à l\'une application',
    'addTeamAndAppMessage': 'Êtes-vous sûr(e) de vouloir l\'accès à cette application ?',
    'deleteAccountTitle': 'Suppression',
    'DeleteAccountMessage': 'Êtes-vous sûr(e) de vouloir supprimer votre compte Swizi ? ' +
      'Un email de confirmation vous sera envoyé lors de sa suppression.',
    'removeFontTitle': 'Suppression de fontes',
    'removeFontMessage': 'Êtes-vous sûr(e) de vouloir supprimer cette famille de fontes ?',
    'confirmPluginUploadTitle': 'Envoyer un fichier Zip',
    'confirmPluginUploadText': 'Le plugin va générer une api key avec les droits suivants : ',
    'confirmPluginUploadText2': '. Voulez-vous continuer ? ',
  },
  'Editor': {
    'title': 'Editer un contenu',
    'urlPlaceholder': 'Saisir un lien web',
    'dropLabel': 'Cliquez pour ouvrir la bibliothèque et glissez un média',
    'slideshowTitle': 'Éditer un slideshow',
  },
  'SectionEditor': {
    'showAllFloorsList': 'Afficher la liste de tout les étages',
    'meetMe': 'Activer la fonctionnalité "meet me"',
    'mapwizeStyleURL': 'Forcer un style différent pour la carte (URL mapwize)',
    'showCalendar': 'Activation de la préview complète du mois en haut de la liste',
    'swipable': 'Défiler l\'écran horizontalement pour passer d\'un onglet à l\'autre (Android)',
    'showLogin': 'Affichage de la partie login',
    'titleCreation': 'Créer une section',
    'titleEdit': 'Configurer une section',
    'titleVisibility': 'Section limitée aux groupes',
    'dropLabel': 'Cliquez pour ouvrir la bibliothèques et glissez un média',
    'titleMapLayers': 'Groupes de POIs affichés',
    'titleMapLayersPlanner': 'Groupes de POIs utilisés dans le Planner',
    'titleGeoLayers': 'Groupes d\'utilisateurs affichés',
    'datasourcesTitle': 'Connecteurs',
    'geolocDevicesTitle': 'Équipements de localisation utilisé',
    'mapWizePOISTitle': 'Venue Mapwize affichée',
    'foldersTitle': 'Dossiers de fichiers utilisés',
    'keyValuesTitle': 'Groupes de clés/valeurs utilisées',
    'apiKeyValuesTitle': 'Groupes de clés/valeurs utilisées',
    'SectionInformations': 'Informations de la section',
    'SectionParams': 'Paramètres de la section',
    'chatApiKey': 'Api Key',
    'chatSecretKey': 'Secret Key',
    'plannerTitle': 'Swizi Planners à utiliser',
    'plannerChat': 'Section chat connectée',
    'plannerMapwize': 'Section MapWize connectée',
    'plannerMap': 'Section Google Map connectée',
    'chatTitle': 'Serveur de messagerie à utiliser',
    'resourceManagerTitle': 'Gestionnaire de ressources utilisé',
    'formTitle': 'Gestionnaire de stockage utilisé',
    'formTable': 'Formulaire',
    'dmTitle': 'Service de Data Mediation utilisé',
    'Parallax': 'Vitesse du parallax avec l\'image d\'arrière plan',
    'PaddingTitle': 'Espacement entre les blocs',
    'PaddingNONE': 'Aucun',
    'PaddingLIGHT': 'Léger',
    'PaddingBIG': 'Grand',
    'buttonPosition': 'Position des boutons',
    'buttonPositionFLOATING': 'Flottant',
    'buttonPositionFIXED': 'Fixed',
    'contentTemplate': 'Template de contenu',
    'contentTemplateType_LIVE': 'Live',
    'contentTemplateType_GENERIC': 'Generic',
    'contentTemplateType_GENERIC_2': 'Generic 2',
    'skip': 'Possibilité de passer l\'on boarding à la fin',
    'dots': 'Afficher la progression',
  },
  'OnBoarding': {
    'Text_Placeholder': 'Entrez du texte personnalisé',
  },
  'Design': {
    'icon': 'Icône de l\'application',
    'iconNotif': 'Icône des notifications',
    'name': 'Nom de l\'application',
    'splashscreen': 'Splashscreen de l\'application',
    'elementDesignTitle': 'Design des éléments',
    'elementDesignSubtitle': 'Définissez ci-dessous le design des éléments graphiques',
    'buttonShape': 'Forme des boutons',
    'buttonStyle': 'Style des boutons',
    'buttonStyleTEXT': 'Texte',
    'buttonStyleICON': 'Icône',
    'buttonStyleTEXT_ICON': 'Texte et icône',
    'shadow': 'Ombre',
    'radius': 'Arrondi',
    'backButtonType': 'Style du bouton Back dans la barre de navigation',
    'backButtonType_CHEVRON': 'Chevron',
    'backButtonType_SQUARED_CHEVRON': 'Chevron dans carré',
    'showNavBarAccount': 'Afficher mon compte dans la barre de navigation',
    'paletteSelector': 'Choix d\'une palette de couleurs',
    'selectedPalette': 'Palette sélectionnée',
    'previewPalette': 'Aperçu de la palette',
    'uiHeader': 'Couleurs',
    'uiTitle': 'Lorem ipsum',
    'uiText': 'Dolor si amet',
    'uiButton': 'Bouton',
    'advanced': 'Avancé',
    'title': 'Identité de l\'application',
    'subTitle': 'Définissez ci-dessous le style de votre marque',
    'logo': 'Logo sur page d\'accueil (barre de navigation)',
    'iconRequirements': 'Format carré recommandé : 1024x1024px',
    'iconNotifRequirements': 'Format carré transparence (512x512px - PNG) - uniquement pour Android',
    'splashRequirements': 'Taille recommandée : 1242x2208px',
    'logoRequirements': 'Taille recommandée : hauteur 35px max',
    'themeTitle': 'Couleurs de l\'application',
    'themeSubtitle': 'Définissez ci-dessous les couleurs de votre application',
    'chooseTheme': 'Choisir un thème',
    'font': 'Personnaliser la police de caractère de l’application',
    'manageFonts': 'Gérer les polices de caractère',
    'fontName': 'Nom de la police',
    'fontRegular': 'Fichier au format ttf pour le style normal (Regular)',
    'fontBold': 'Fichier au format ttf pour le style gras (Bold)',
    'fontItalic': 'Fichier au format ttf pour le style italic (Italic)',
    'fontList': 'Liste des polices personnalisées importées',
    'fontAdd': 'Ajouter une nouvelle police',
    'needPaletteSave': 'Veuillez enregistrer le changement de palette pour modifier ensuite les autres couleurs',
    'colorChooserEditor': 'Choix des couleurs',
    'color': 'Couleur',
    'opacity': 'Opacité',
    'Colors': {
      'COLOR_MENU_ICON': 'Couleur des icônes des rubriques',
      'COLOR_MENU_ICON_SELECTED': 'Couleur de l\'icône de la rubriques sélectionnée',
      'COLOR_MENU_TEXT': 'Couleur du texte des items',
      'COLOR_MENU_TEXT_SELECTED': 'Couleur du texte de l\'item sélectionné',
      'COLOR_MENU_BACK_ITEM': 'Couleur de fond des items',
      'COLOR_MENU_BACK_SELECTED': 'Couleur de fond de l\'item sélectionné',
      'COLOR_MENU_BACK': 'Couleur de fond',
      'COLOR_MENU_ACCOUNT_BACK': 'Couleur de fond de l\'item en bas du menu',
      'COLOR_NAVBAR_BACK': 'Couleur de la barre de navigation',
      'COLOR_NAVBAR_ICON_TINT': 'Couleur des icônes de la barre de navigation',
      'COLOR_NAVBAR_TEXT': 'Couleur du texte de la barre de navigation',
      'COLOR_QL_BACK': 'Couleur de fond des items',
      'COLOR_QL_BACK_SELECTED': 'Couleur de fond de l\'item sélectionné',
      'COLOR_QL_ICON': 'Couleur des icônes',
      'COLOR_QL_ICON_SELECTED': 'Couleur de l\'icône sélectionnée',
      'COLOR_QL_TEXT': 'Couleur du texte des items',
      'COLOR_QL_TEXT_SELECTED': 'Couleur du texte de l\'item sélectionné',
      'COLOR_ITEM_TEXT_BACK': 'Couleur de fond des items',
      'COLOR_ITEM_SEPARATOR': 'Couleur de séparateur des items',
      'COLOR_USER_COLOR_1': 'Couleur de fond de l\'item sélectionné',
      'COLOR_USER_COLOR_3': 'Couleur de fond de l\'item en bas du menu',
      'COLOR_ITEM_TITLE': 'Couleur du titre d\'un item',
      'COLOR_ITEM_TITLE_SELECTED': 'Couleur du titre d\'un item sélectionné',
      'COLOR_GLOBAL_BACK': 'Couleur de fond',
      'COLOR_ITEM_BACK': 'Couleur de fond du titre',
      'COLOR_ITEM_INTRODUCTION': 'Couleur du sous-titre',
    },
    'generatePaletteFromFile': 'Générer des couleurs depuis une photo',
    "linkColor": "Lier à une couleur générique"
  },
  'User': {
    'all': 'Tous',
    'id': 'ID',
    'Lastname': 'Nom',
    'Firstname': 'Prénom',
    'Login': 'Login',
    'Email': 'E-mail',
    'lastLogin': 'Dernière connexion',
    'nbApps': 'Nb applications',
    'Twitter': 'Compte Twitter',
    'Group': 'Groupe(s)',
    'SpecificGroup': 'Groupe(s) spécifiques',
    'Status': 'Status',
    'Phone': 'Numéro de téléphone',
    'MobilePhone': 'Téléphone mobile',
    'Password': 'Mot de passe',
    'newPassword': 'Nouveau mot de passe',
    'CPassword': 'Confirmer le mot de passe',
    'changePassword': 'Changer le mot de passe',
    'deleteAccount': 'Demander la suppression de mon compte',
    'configRights': 'Droits de configuration',
    'contentRights': 'Droits de contenu',
    'USER_RIGHTS': {
      'DATA_LOCALISATION_DEVICE': 'Equipement de localisation',
      'DATA_LOCALISATION_BEACON': 'Localisation de beacons',
      'DATA_LOCALISATION_STIMSHOP': 'Localisation Stimshop',
      'DATA_POI': 'Points d\'intérêts',
      'DATA_MAPWIZE': 'Mapwize',
      'DATA_FILE': 'Fichiers',
      'DATA_KEY_VALUE': 'Clés valeurs',
      'DATA_PLANNING': 'Planning',
      'DATA_CHECKIN': 'Checkin',
      'DATA_CHAT': 'Messagerie instantanée',
      'DATA_RESOURCE_MANAGER': 'Gestionnaire de ressources',
      'DATA_FORM': 'Formulaire',
      'DATA_GENERIC': 'Connecteur générique',
      'DATA_DM': 'Data mediation',
      'PLUGIN': 'Plugin',
      'PLANNER': 'Planning',
      'CHAT': 'Messagerie instantanée',
      'MAPWIZE': 'Mapwize',
      'STIMSHOP': 'Stimshop',
      'FILE': 'Fichiers',
      'KEY_VALUE': 'Clés valeurs',
      'RESOURCE_MANAGER': 'Ressources',
      'FORM': 'Formulaire',
      'DM': 'Data mediation',

    },
    'UsersTitle': 'Liste des utilisateurs',
    'FormLastNameValidation': '60 caractères maximums, lettres uniquement',
    'FormFirstNameValidation': '60 caractères maximums, lettres uniquement',
    'FormEMailValidation': '60 caractères maximums, lettres, chiffre et @ autorisés',
    'FormPasswordValidation': '64 caractères maximums, au moins 1 lettre, 1 chiffre et 1 caractère spécial',
    'FormPhoneValidation': '20 caractères maximums, chiffres uniquement',
    'importUsers': 'Importer des utilisateurs',
    'importSend': 'Sélectionner et envoyer',
    'importExample': 'Télécharger un exemple de fichier à importer',
    'addGroup': 'Ajouter un groupe',
    'importAzure': 'Import depuis Azure AD',
    'addUser': 'Ajouter un utilisateur',
    'editGroup': 'Modifier un groupe',
    'editUser': 'Modifier un utilisateur',
    'active': 'Actif',
    'inactive': 'Inactif',
    'ActiveAccount': 'Compte actif',
    'Team': {
      'profile': 'Profil',
      'noMember': 'Aucun membre dans l\'équipe',
      'addMember': 'Ajouter un membre',
      'deleteMember': 'Supprimer ce membre de l\'équipe',
    },
    'Configuration': 'Configuration',
    'ModeParticipation': 'Mode de participation',
    'Auths': 'Types d\'authentification',
    'showInfo': 'Informations du profil à afficher',
    'Participation': {
      'MIXED': 'Mixte',
      'PUBLIC': 'Public',
      'PRIVATE': 'Privé',
      'GAMO': 'Swizi',
      'Facebook': 'Facebook',
      'Twitter': 'Twitter',
      'LDAP': 'Annuaire LDAP',
      'WS': 'Web service',
      'AZURE_AD': 'Azure AD',
    },
    'loginType': 'Type de login',
    'loginTypes': {
      'FULLSCREEN_CLASSIQUE': 'Classique plein-écran',
      'POPUP': 'Popup',
      'ENROLL_SMS': 'Inscription par SMS',
    },
    'smsSender': 'Expéditeur du SMS',
    'profileTemplate': 'Type de profil',
    'profileTemplates': {
      'CLASSIC': 'Profil basique',
      'DYNAMIC': 'Profil avancé (avec choix des informations affichées)',
    },
    'profileInfo': {
      'login': 'Login',
      'email': 'Email',
      'firstname': 'Prénom',
      'lastname': 'Nom',
      'company': 'Entreprise',
      'function': 'Fonction',
      'phone': 'Téléphone fixe',
      'mobilePhone': 'Téléphone mobile',
      'age': 'Age',
      'addrLine1': 'Adresse 1',
      'addrLine2': 'Adresse 2',
      'zipCode': 'Code postal',
      'city': 'Ville',
      'country': 'Pays',
    },
    'importLdapGroups': 'Récupérer les groupes de l\'annuaire',
    'importLdapUsers': 'Récupérer les utilisateurs de l\'annuaire',
    'azureConfig': 'Configuration Azure AD',
    'azureConfigClientId': 'ID client',
    'azureConfigSecret': 'Secret',
    'azureConfigTenant': 'Tenant',
    'azureConfigCheckSynchro': 'Vérifier la configuration de synchro avec Azure AD',
    'ldapTest': 'Tester la connexion à l\'annuaire LDAP',
    'wsConfig': 'Configuration du web service d\'authentification',
    'loginTimeout': 'Expiration du login (minutes)',
    'tokenTimeout': 'Expiration du jeton (minutes)',
    'forgottenPwd': 'Mot de passe oublié activé',
    'updatePhoto': 'Modification de photo activée',
    'blockAccountCreation': 'Bloquer la création de compte',
    'useBiometric': 'Activer l\'authentification biométrique',
    'activateAccount': 'Afficher l\'activation de compte',
    'accountCreationGroups': 'Groupes par défaut à la création d\'utilisateurs',
    'errors': {
      'alreadyUsed': 'L\'email est déjà utilisé',
    },
  },
  'Group': {
    'Label': 'Nom',
    'Description': 'Description',
    'Type': 'Type',
    'Type_SPACE': 'Espace',
    'Type_GROUP': 'Groupe',
    'Type_AZURE_AD': 'Azure AD',
    'Geoloc': 'Géolocalisable',
    'GeolocInterval': 'Interval de géolocalisation',
    'Subscription': 'Centre d\'intérêt (auto-inscription)',
    'SubscriptionInformation': 'Description du centre d\'intérêt',
    'DefaultSpace': 'Espace par défaut',
    'GroupsTitle': 'Groupes d\'utilisateurs',
    'FormLabelValidation': '60 caractères maximums, lettres, chiffre et caractères spéciaux autorisés',
    'FormDescriptionValidation': '255 caractères maximums, lettres, chiffre et caractères spéciaux autorisés',
  },
  'Icons': {
    'publication': 'Publication',
    'access_evenement': 'Acces événement',
    'participants': 'Participants',
    'realite_augmentee': 'Réalité augmentée',
    'business_commerce_banque': 'Business / Commerce / Banque',
    'objectifs_commerciaux_bilans_analytics': 'Objectifs commerciaux / Bilans / Analytics',
    'business_commerce_banque2': 'Business / Commerce / Banque 2',
    'intervenants': 'Intervenants',
    'application_evenement': 'Application / Événements',
    'culture_musique_theatre': 'Culture / Musique / Théâtre',
    'galerie_photos_videos': 'Galerie / Photos / Vidéos',
    'plan_interactif': 'Image interactive',
    'infos_pratiques': 'Infos pratiques',
    'accueil': 'Accueil',
    'activites_sportives': 'Activités sportives',
    'social_wall': 'Social Wall',
    'autres_activites': 'Autres activités',
    'meteo': 'Météo',
    'hebergement': 'Hébergement',
    'quizz': 'Quizz',
    'activites_sportives2': 'Activités sportives 2',
    'sponsor_solidarite_partenaire': 'Sponsor / Solidarité / Partenaire',
    'a_propos': 'À propos',
    'selfie': 'Selfie',
    'agenda': 'Agenda',
  },
  'sections': {
    'filterPlaceholder': 'Par groupes',
    'filterPlaceholders': 'Groupes',
    'filterPlaceholderType': 'Par types',
    'params': 'Personnalisation de l\'écran',
    'paramsSettings': 'Paramètres du contenu',
    'paramsSettingsKey': 'Clé',
    'paramsSettingsValue': 'Valeur',
    'dashboard': {
      'title': 'Choix du template d\'écran',
      'dnd': 'Glissez une section',
      'slideshowParam': 'Cliquez pour paramétrer le slideshow',
      'HEADER_SLIDESHOW': 'En-tête et galerie d\'images',
      'HEADER_SLIDESHOW_TILES': 'En-tête, galerie d\'image et tuiles',
      'SLIDE_SHOW_FULLSCREEN': 'Galerie d\'image plein écran',
      'HONEYCOMB': 'Galerie d\'image plein écran, tuiles héxagonales',
      'TAB_CONTAINER': 'Conteneur multi-vues',
      'labelHeaderHC': 'Accroche',
      'GENERIC_LIST': 'Liste',
      'LIVE': 'Live',
      'LIVE 2': 'Live 2',
      'RSS_CLASSIC': 'Liste classique',
      'RSS_CARDS': 'Tuiles',
      'CARDS': 'Cards',
      'MATERIAL_CARDS': 'Material cards',
      'LEFT_RIGHT_CARDS': 'Left/right cards',
      'PEOPLE': 'People',
      'ACTION_LIST': 'Liste actions',
    },
    'plan': {
      'planParam': 'Cliquez pour paramétrer une nouvelle image interactive',
      'namePlaceholder': 'Nommez l\'image',
      'areas': 'Zones interactives',
      'drop': 'Image d\'arrière plan',
      'edit': 'Modifier l\'image interactive',
      'delete': 'Supprimer l\'image interactive',
      'addBackImage': 'Ajouter une image d\'arrière plan',
      'deleteBackImage': 'Supprimer l\'image d\'arrière plan',
      'zones': {
        'add': 'Ajouter une zone',
        'edit': 'Modifier la zone',
        'delete': 'Supprimer la zone',
      },
    },
    'map': {
      'poi': {
        'add': 'Ajouter un POI',
        'edit': 'Modifier le POI',
        'delete': 'Supprimer le POI',
        'choose': 'Placer le POI',
        'addAction': 'Ajouter une action',
        'editAction': 'Modifier une action',
        'genericAction': 'Action supplémentaire',
        'search': 'Rechercher une adresse',
        'noPoi': 'Il n\'y a pas de POI configuré. Veuillez en ajouter dans la rubrique Connecteurs.',
        'selectType': 'Sélectionner un type de POI',
        'mapwizeVenue': 'Venue',
        'mapwizePlace': 'Place',
        'groups': 'Groupes',
      },
    },
    'mapwize': {
      'errorApp': 'Erreur à l\'initialisation de Mapwize. Veuillez vérifier la configuration ' +
        'Mapwize de l\'application.',
      'errorSection': 'Erreur à l\'initialisation de Mapwize. Veuillez vérifier la configuration ' +
        'Mapwize de la section.',
    },
    'colors': {
      'TAB_BAR_BACKGROUND': 'Couleur de la tabbar',
      'TAB_BAR_SELECTED_TAB': 'Couleur de l\'onglet sélectionné',
    },
    'dimensions': 'Dimension',
    'dimensionsXSmall': 'Très petite',
    'dimensionsSmall': 'Petite',
    'dimensionsMedium': 'Moyenne',
    'dimensionsLarge': 'Grande',
    'backgroundImage': 'Image d\'arrière plan de la tuile',
    'sectionTarget': 'Section',
    'actionTarget': 'Interaction utilisateur',
    'titleTarget': 'Titre',
    'icon': 'Icône',
    'color': 'Couleur',
    'sectionNotClickable': 'Section non cliquable',
    'hideTitle': 'Masquer le titre',
    'template': 'Template',
    'templateType_DEFAULT': 'Défaut',
    'templateType_TITLE': 'Titre',
    'templateType_TITLE_NOTIFICATION': 'Titre avec centre de notification',
    'templateType_LIST_PREVIEW': 'Prévisualisation liste',
    'templateType_CARD_PREVIEW': 'Prévisualisation card',
    'templateType_TAGGED_ITEM_WITH_ROW': 'Contenu à la une avec ligne',
    'templateType_TAGGED_ITEM_WITH_COLUMN': 'Contenu à la une avec colonne',
    'templateType_TAGGED_CARD_ITEM_WITH_ROW': 'Cards avec contenu à la une et ligne',
    'arrowType': 'Type de flèche',
    'imageRatio': 'Ratio de l\'image',
    'imageRatio_DEFAULT': 'Carré',
    'imageRatio_LANDSCAPE': 'Paysage',
    'imageRatio_PORTRAIT': 'Portrait',
    'arrowType_DEFAULT': 'Défaut',
    '$firstname': 'Prénom de l\'utilisateur',
    '$lastname': 'Nom de l\'utilisateur',
    'arrowType_SQUARED_CHEVRON': 'Chevron dans carré',
    'actionLayout': 'Disposition des actions',
    'actionLayout_VERTICAL': 'Vertical',
    'actionLayout_HORIZONTAL': 'Horizontal',
    'numberOfItems': 'Nombre d\'éléments',
    'actionShowDots': 'Afficher les points d\'actions',
    'showNotificationCenter': 'Afficher le centre de notification',
    'canShowTitleAbove': "Afficher le titre de la section au dessus du contenu",
    "canShowElevation": "Afficher le contenu avec un effet d'élévation"
  },
  'select': {
    'placeholder': 'Sélectionnez un élément',
    'placeholderProfile': 'Sélectionnez un profil',
    'placeholderIcon': 'Recherchez une icône',
    'placeholderSectionTags': 'Par catégories',
    'placeholderSectionName': 'Par section',
    'placeholderImage': 'Recherchez une image',
    'placeholderGenericTitle': 'Ajouter un texte dynamique',
    'noResult': 'Aucun résultat trouvé',
  },
  'GenericAction': {
    'description': 'Sélection d\'une action',
    'name': 'Nom',
    'i18nTitle': 'Titre',
    'action': 'Action',
    'nothing': '--',
    'url_external': 'Ouvrir un lien web externe',
    'type_section': 'Afficher une section',
    'type_popup': 'Ouvrir une popup',
    'type_plan': 'Afficher une image interactive',
    'type_login': 'Ouvrir l\'écran de login',
    'type_logout': 'Se déconnecter',
    'type_create_account': 'Ouvrir l\'écran de création de compte',
    'type_resetPassword': 'Ouvrir l\'écran de réinitialisation du mot de passe',
    'type_changePassword': 'Ouvrir l\'écran de changement du mot de passe',
    'type_subscription': 'Ouvrir le panneau des souscriptions',
    'title': 'Editer une action',
    'params': 'Paramètres au format URI',
    'type_sync_section': 'Synchro section',
    'type_sync_refresh_token': 'Refresh token',
    'type_sync_clean_cache': 'Vider le cache',
  },
  'Crop': {
    'PleaseCropIcon': 'Merci de sélectionner une portion carré de l\'image',
    'PleaseCropSplash': 'Merci de sélectionner une portion 16/9 en mode portrait de l\'image',
    'Validate': 'Valider',
  },
  'IOTMenu': {
    'title': 'Connecteurs',
    'beaconTitle': 'Équipements de localisation',
    'beaconParametre': 'Configuration',
    'beaconListe': 'Liste',
    'beaconAction': 'Actions',
    'beaconPlan': 'Plan',
    'poiAddGroup': 'Ajouter une catégorie',
    'poiEditGroup': 'Modifier une catégorie',
    'poiTitle': 'Points d\'intérêts',
    'mapWizeTitle': 'MapWize',
    'resourcesTitle': 'Fichiers',
    'keyValueTitle': 'Données clé/valeur',
    'apiTitle': 'Données fournies par l\'API',
    'mapWizeAddVenu': 'Ajouter une venue',
    'resourceAdd': 'Ajouter un dossier',
    'keyValueAdd': 'Ajouter un groupe de données',
    'apiKeyValueAdd': 'Ajouter un groupe de données API',
    'mapwizeEditVenue': 'Modifier une Venue',
    'mapwizeAddVenue': 'Ajouter une Venue',
    'filesEditFolder': 'Modifier un dossier',
    'filesAddFolder': 'Ajouter un dossier',
    'keyvalueEditCategory': 'Modifier une catégorie',
    'keyvalueAddCategory': 'Ajouter une catégorie',
    'apikeyvalueEditCategory': 'Modifier une catégorie',
    'apikeyvalueAddCategory': 'Ajouter une catégorie',
    'plannerTitle': 'Planning',
    'plannerAdd': 'Ajouter un service planning',
    'checkinTitle': 'Checkin',
    'checkinAdd': 'Ajouter un service checkin',
    'chatTitle': 'Messagerie instantanée',
    'chatAdd': 'Ajouter un service de messagerie',
    'resourceManagerTitle': 'Gestionnaire de ressources',
    'resourceManagerAdd': 'Ajouter un gestionnaire de ressources',
    'formTitle': 'Gestionnaire de stockage',
    'formAdd': 'Ajouter un gestionnaire de stockage',
    'dmTitle': 'Service de data mediation',
    'dmAdd': 'Ajouter un service de data mediation',
    'genericTitle': 'Connecteur générique',
    'genericAdd': 'Ajouter un connecteur générique',
  },
  'Beacon': {
    'activationGlobal': 'Activation des beacons',
    'layoutBeacon': 'Types de beacons',
    'layoutSelectHint': 'Sélectionnez un type d\'équipement',
    'titleEditorEdit': 'Editer un un équipement de localisation',
    'titleEditorCreate': 'Ajouter un équipement de localisation',
    'colActive': 'Actif',
    'colName': 'Nom',
    'colUUID': 'Adresse Mac (XX:XX:XX:XX:XX:XX)',
    'OtherID': 'UUID & Majeur - Mineur',
    'colStrength': 'Puissance du signal',
    'colPower': 'Puissance',
    'colLastSeen': 'Dernière vue',
    'delete': 'Supprimer l\'équipement de localisation',
    'edit': 'Editer l\'équipement de localisation',
    'Major': 'Majeur',
    'Minor': 'Mineur',
    'macAddress': 'Adresse Mac',
    'audioSignal': 'Signal Audio',
    'placeholderAudio': 'Sélectionnez un signal',
    'downloadAudio': 'Télécharger le fichier audio',
    'Action': {
      'delete': 'Supprimer l\'action',
      'edit': 'Modifier l\'action',
      'listTitle': 'Liste des actions',
      'concernedBeacon': 'Beacon concerné',
      'listOfGroups': 'Groupes concernés',
      'detectionType': 'Action',
      'addAction': 'Ajouter une action',
      'genericAction': 'Action',
      'actionNumber': 'Action #{index}',
      'name': 'Nom de l\'action',
      'groups': 'Groupes associés à l\'action',
      'start': 'Heure de début de détection',
      'end': 'Heure de fin de détection',
      'detectionDate': 'Jour de détection',
      'detection': 'Type de détection',
      'detectionTypes': {
        'PROXIMITY': 'À proximité',
        'ENTER_ZONE': 'Entrée de zone',
        'EXIT_ZONE': 'Sortie de zone',
      },
      'frequency': 'Fréquence de détection',
      'frequencyTypes': {
        'ONCE': 'Une fois',
        'EVERY_MIN': 'Toutes les minutes',
        'EVERY_15_MIN': 'Toutes les 15 minutes',
        'EVERY_30_MIN': 'Toutes les 30 minutes',
        'EVERY_HOUR': 'Toutes les heures',
        'EVERY_6_HOURS': 'Toutes les 6 heures',
        'EVERY_DAY': 'Tous les jours',
      },
      'nbMax': 'Nombre de détections maximum',
    },
    'noBeacon': 'Il n\'y a pas de beacon configuré. Veuillez en ajouter au moins un, puis quand un utilisateur' +
      ' détectera un beacon, sa position sera affichée sur la carte.',
    'mapBeaconToMapWize': 'Connecter un équipement de localisation',
    'mapGMapsToMapWize': 'Connecter un POI Google Maps',
    'showAllMapWizePlaces': 'Afficher tous les POIs',
    'maskAllMapWizePlaces': 'Masquer',
    'display': 'Afficher',
  },
  'Tour': {
    'prevBtn': 'Précédent',
    'nextBtn': 'Suivant',
    'doneBtn': 'Fini',
    'skipBtn': 'Passer',
    'closeBtn': 'Fermer',
  },
  'CGU': {
    'writeCGU': 'Rédaction des Conditions Générales d\'Utilisation :',
  },
  'PrivacyPolicy': {
    'writePolicy': 'Rédaction de la politique de protection des données :',
  },
  'Deploy': {
    'apiKey': 'API key',
    'appID': 'App ID',
    'certif': {
      'current': 'Actuel : ',
      'file': 'Fichier du certificat de push iOS',
      'password': 'Mot de passe du certificat de push iOS',
      'keystore': 'Keystore Android',
      'manageKeystore': 'Gérer le keystore',
      'genKeystore': 'Générer un keystore',
      'launchGen': 'Générer un nouveau',
    },
    'steps': {
      'building': 'Construction',
      'generate': 'Génération',
      'storeDeposit': 'Dépôt sur les Stores',
      'waitingApproval': 'Attente de validation',
      'available': 'Disponible',
    },
    'specific': 'Informations nécessaires',
    'iosSpecific': 'Information pour iOS',
    'androidSpecific': 'Information pour Android',
    'accountEmailIOS': 'Adresse e-mail du compte développeur Apple',
    'accountPasswordIOS': 'Mot de passe du compte développeur Apple',
    'accountEmailAndroid': 'Adresse e-mail compte développeur Google',
    'accountPasswordAndroid': 'Mot de passe compte développeur Google',
    'keystorePasswordAndroid': 'Mot de passe du Keystore',
    'keyAliasAndroid': 'Key alias',
    'keyPasswordAndroid': 'Key password',
    'hashAndroid': 'Hash',
    'googleJSON': 'Google JSON',
    'androidGCMID': 'GCM ID utilisé pour le push',
    'version': 'Version',
    'common': 'Information communes',
    'BundleID': {
      'iOS': 'Nom de package pour iOS',
      'android': 'Nom de package pour Android',
    },
    'KeyWords': 'Mots clés pour les stores (séparés par des ,)',
    'PrivacyPolicyModel': 'Utiliser la déclaration de confidentialité de Swizi',
    'PrivacyPolicyURL': 'URL d\'accès à la déclaration de confidentialité',
    'WritePrivacyPolicy': 'Ou rédigez la ici',
    'ContactEmail': 'E-mail de contact',
    'DemoAccount': 'Compte de démo',
    'DemoAccountPassword': 'Mot de passe du compte de démo',
    'askDeploy': 'Déployer',
    'store': {
      'public': 'App Store & Google Play Store',
      'publicAndroid': 'Google Play Store',
      'publicIOS': 'App Store',
      'private': 'Store privé KStore',
      'manual': 'Manuel',
      'publicInfo': 'L\'application sera disponible pour tout le monde à travers le Store sur mobile. ' +
        'Il faut compter plusieurs jours pour la mise à disposition auprès des utilisateurs.',
      'privateInfo': 'L\'application sera disponible pour les personnes ayant accès au KStore. ' +
        'Il faut compter moins d\'une journée pour la mise à disposition auprès des utilisateurs',
      'manualInfo': 'C\'est à vous de rendre l\'application disponible par le moyen que vous souhaitez. ' +
        'Pour iOS, veuillez nous contacter pour choisir le type de déploiement (in house / AppStore).',
    },
    'errors': {
      'package': {
        'ios': 'Ce nom de package est déjà utilisé sur l\'App Store',
        'android': 'Ce nom de package est déjà utilisé sur le Play Store',
      },
    },
    'iOSDisclaimer': 'Nous ne demandons, pour iOS, que votre compte de développeur. ' +
      'Ou un AppleID dédié à Swizi. ' +
      'Nous ne demandons pas plus d\'informations, car il sera plus simple pour nous d\'aller ' +
      'créer les certificats et provisionning profiles nécessaire à la génération de l\'application.',
  },
  'Api': {
    'manageKeys': 'Gestion des clés d\'API',
    'addApiKey': 'Ajouter une clé d\'api',
    'nameKey': 'Libellé',
    'valueKey': 'Valeur',
    'dateKey': 'Date de génération',
    'activeKey': 'Active',
    'authKey': 'Sécurisée',
    'authorizations': 'Autorisations',
    'editKey': 'Editer la clé',
    'addKey': 'Ajouter une clé',
    'active': 'Oui',
    'inactive': 'Non',
  },
  'NotifMenu': {
    'title': 'Notifications',
    'notificationCenter': 'Centre de notification',
    'send': 'Envoi de notifications',
    'followUp': 'Notifications programmées',
    'history': 'Historique des notifications',
  },
  'NotifInfo': {
    'followUpManagement': 'Notifications programmées',
    'history': 'Historique des notifications',
    'type': 'Type',
    'typeCONTENT': 'Contenu',
    'typeFILTER': 'Ciblé',
    'title': 'Titre',
    'message': 'Message',
    'notifDate': 'Date de notification',
    'nbDevices': 'Nb de devices',
    'action': 'Action',
  },
  'Notif': {
    'date': 'Date',
    'sendBtTitle': 'Envoyer les notifications',
    'sendBtLabel': 'Envoyer',
    'technical': 'Notification technique',
    'title': 'Titre',
    'titlePlaceHolder': 'Titre de la notification',
    'message': 'Message',
    'messagePlaceHolder': 'Message à destination de vos utilisateurs',
    'action': 'Action générique',
    'actionPlaceHolder': 'Définir une action',
    'actionUpdate': 'Modifier l\'action',
    'diffusionMode': 'Type de diffusion :',
    'everyone': 'Tout le monde',
    'filter': 'Cibler',
    'panelGroup': 'Groupes',
    'panelGeoloc': 'Géolocalisation',
    'clearGeoloc': 'Effacer la sélection',
    'panelDevices': 'Appareils',
    'panelProperties': 'Propriétés utilisateurs',
    'filterByGroup': 'Filtrer par groupes',
    'filterByUsers': 'Filtrer par utilisateurs',
    'createUserOption': 'Ajouter l\'identifiant "',
    'inputIdentifier': 'Saisir un identifiant ...',
    'filterByDeviceOS': 'Filtrer par système d\'exploitation',
    'filterByDeviceLang': 'Filtrer par langue',
    'errorMessageEmpty': 'Le message ne doit pas être vide',
    'errorTitleEmpty': 'Le titre ne doit pas être vide',
  },
  'Admin': {
    'users': 'Utilisateurs',
    'profiles': 'Profils',
    'applications': 'Applications',
    'icons': 'Icônes',
    'images': 'Images',
  },
  'AdminProfiles': {
    'title': 'Profils',
    'add': 'Ajout d\'un profil',
    'edit': 'Edition d\'un profil',
    'name': 'Nom',
    'desc': 'Description',
    'level': 'Niveau',
    'properties': 'Autorisations',
    'freemium': 'Offre freemium',
    'Error': {
      'name': 'Erreur dans le nom du profil',
      'desc': 'Erreur dans la description du profil',
      'level': 'Erreur dans le niveau du profil',
      'add': 'Erreur lors de l\'enregistrement du profil',
    },
  },
  'AdminApplications': {
    'title': 'Applications',
    'id': 'Id',
    'name': 'Nom',
    'owner': 'Propriétaire',
    'version': 'Version',
    'versionCode': 'Version Code',
    'apiKey': 'Clé d\'API',
    'creation': 'Création',
    'status': 'Statut',
    'edit': 'Editer l\'application',
    'deactivatePwd': 'Désactiver la vérification du mot de passe',
  },
  'Analytics': {
    'title': 'Statistiques',
    'countly': {
      'instructions': 'Pour accéder aux statistiques de l\'application : ',
      'instructions2': 'Cliquez sur le ',
      'instructions3': 'lien externe vers Countly.',
      'instructions4': 'Lors de votre première authentification, faites un mot de passe oublié en utilisant ' +
        'l\'e-mail de votre compte Swizi.',
      'instructions5': 'Une fois authentitié, cliquez sur le menu "Statistiques" et sélectionner l\'application ',
    },
    'today': 'Aujourd\'hui',
    '7days': '7 jours',
    '30days': '30 jours',
    '60days': '2 mois',
    '90days': '3 mois',
    'year': '1 an',
    'totalSessions': 'Nombre total de sessions',
    'totalUsers': 'Nombre total d\'utilisateurs',
    'newUsers': 'Nombre de nouveaux utilisateurs',
    'totalTime': 'Temps total d\'utilisation',
    'avgTime': 'Temps moyen d\'utilisation',
    'topPlatform': 'Top OS',
    'topResolutions': 'Top résolutions',
    'topCarriers': 'Top opérateur',
    'topUsers': 'Top arrivée de nouveaux utilisateurs',
    'noStatDatas': 'Aucune donnée n\'est pour le moment disponible',
    'useAnEvent': 'Sélectionnez un événement pour obtenir ses statistiques',
    'events': {
      'SCR_SPLASHSCREEN': 'Splashscreen',
      'SCR_WELCOME': 'Accueil',
      'SCR_INTERSTICIAL': 'Interserticiel',
      'SCR_LEGAL_MENTION': 'Mentions légages',
      'EV_CLICK_INTERSTICIEL': 'Interserticiel - Click',
      'EV_CLICK_SHARE_APP': 'App - Partage',
      'EV_SKIP_AUTHENTIFICATION': 'Connexion - Passer',
      'SCR_AUTHENTIFICATION': 'Connexion',
      'SCR_SIGNUP': 'S\'enregistrer',
      'SCR_LOST_PASSWORD': 'Mot de passe oublié',
      'EV_AUTH_BAD_LOGIN': 'Connexion - Erreur connexion',
      'EV_AUTH_BAD_SIGNUP': 'Connexion - Erreur enregistrement',
      'EV_AUTH_OK': 'Connexion - Connexion OK',
      'EV_AUTH_FB_OK': 'Connexion - Connexion FaceBook OK',
      'EV_AUTH_TWITTER_OK': 'Connexion - Connexion Twitter OK',
      'EV_SIGNUP_OK': 'Connexion - Enregistrement OK',
      'SCR_DASHBOARD': 'Présentation',
      'EV_QL_CLIC': 'Présentation - Click Item',
      'EV_SLIDESHOW_CLIC': 'Présentation - Click Slideshow',
      'EV_SLIDESHOW_SHARE': 'Présentation - Click partage slideshow',
      'SCR_QUIZZ_LIST': 'Liste de quizz',
      'SCR_QUIZZ': 'Quizz',
      'EV_QUIZZ_SEND_ANSWER': 'Quizz - Envoi réponse',
      'SCR_PLAN': 'Image interactive',
      'EV_PLAN_CLIC_ZONE': 'Image interactive - Click zone',
      'SCR_AGENDA': 'Agenda',
      'SCR_AGENDA_SESSION': 'Agenda - Session',
      'EV_AGENDA_FAVORIS': 'Agenda - Favoris',
      'EV_AGENDA_ADD_CALENDAR': 'Agenda - Ajout calendrier',
      'EV_AGENDA_SEND_QUESTION': 'Agenda - Envoi de question',
      'SCR_SOCIAL': 'Social',
      'EV_SOCIAL_WRITE_TWEET': 'Social - Tweet',
      'SCR_GALLERY_LIST': 'Liste Galerie',
      'SCR_GALLERY_DETAIL': 'Détail d\'une galerie',
      'EV_GALLERY_SHARE': 'Galerie - Partage',
      'SCR_GENERIC_LIST': 'Liste Générique',
      'SCR_GENERIC_DETAIL': 'Détail générique',
      'SCR_GENERIC_WEB': 'Détail page Web',
      'EV_BEACON': 'Beacon - Détection',
      'EV_SHOW_MENU_PERSO': 'Menu - Menu perso',
      'EV_MENU_DISCONNECT': 'Menu - Déconnexion',
      'EV_MENU_CONNECT': 'Menu - Connexion',
      'SCR_MY_ACCOUNT': 'Mon compte',
      'SCR_CARTE_VISITE': 'Ma carte de visite',
      'SCR_MY_PASS': 'Mon Pass',
      'SCR_SELFIE': 'Selfie',
      'EV_SELFIE_TAKE': 'Selfie - Prise de photo',
      'EV_SELFIE_SHARE': 'Selfie - Partage',
      'EV_SELFIE_DELETE': 'Selfie - Suppression',
      'EV_NOTIF_SHOW': 'Notification - Affichage',
      'EV_NOTIF_CLIC': 'Notification - Click',
      'EV_LAUNCH_ROUTE': 'Carte - Itinéraire',
      'EV_PARAM_BLE_DISABLE': 'Paramètres - BLE OFF',
      'EV_PARAM_BLE_ENABLE': 'Paramètres - BLE ON',
      'EV_PARAM_NOTIF_DISABLE': 'Paramètres - Push OFF',
      'EV_PARAM_NOTIF_ENABLE': 'Paramètres - Push ON',
      'EV_LANG': 'Langue',
    },
  },
  'rights': {
    'title': 'Voici les différents profiles et autorisations possibles pour les utilisateurs. ' +
      'Vous pouvez visualiser ces informations à tout moment en affichant l\'aide.',
    'updateNavigation': 'Mise à jour de la navigation',
    'updateApp': 'Mise à jour de l\'app',
    'selectVersionApp': 'Sélectionner une version d\'app',
    'manageUsers': 'Gérer les utilisateurs',
    'designerExpert': 'Designer expert',
    'deployment': 'Déployer',
    'deleteApp': 'Supprimer l\'app',
    'createVersionApp': 'Créer une version d\'app',
    'createSection': 'Créer une section',
    'createCopyApp': 'Créer une copie d\'app',
    'createApp': 'Créer une app',
    'admin': 'Administrer',
    'updateSection': 'Mise à jour de sections',
    'manageApiKeys': 'Gérer les API Keys',
    'manageFreemium': 'Gérer les comptes Fremium',
    'canNotify': 'Notifier',
    'playerOnly': 'Accès au player',
  },
  'Datasource': {
    'key': 'Clé',
    'value': 'Valeur',
    'valueEnter': 'Utilisez la touche Entrer pour ajouter le tag',
    'addKeyValue': 'Ajouter une clé/valeur',
    'scope': 'Scope',
    'param': 'Type',
    'addFile': 'Ajouter un fichier',
    'name': 'Nom',
    'size': 'Taille',
    'date': 'Date de création',
    'kb': 'Ko',
    'mb': 'Mo',
    'OTHER': 'CUSTOM',
    'BADGE': 'BADGE',
    'VISIBILITY': 'VISIBILITY',
    'COLOR_NAVBAR': 'Couleur de la barre de navigation',
    'nonEditableValue': 'Le scope USER permet d\'avoir une valeur par utilisateur',
    'minutesUnit': 'minute(s)',
    'urlMS': 'URL du service',
    'apiKey': 'Clé d\'API',
    'secretKey': 'Clé secrète',
    'type': 'Type',
    'subscribePath': 'URI de souscription',
    'updatePath': 'URI de modification',
    'plannerId': 'Identifiant du planning',
    'plannerName': 'Nom du planning',
    'plannerType': 'Type de planning',
    'plannerVersion': 'Version de planning',
    'category': 'Categorie',
    'userId': 'Identifiant de l\'utilisateur',
    'groupId': 'Groupe',
    'poiId': 'Identifiant du POI',
    'delayBeforeCheckin': 'Délai avant le checkin',
    'duration': 'Durée',
    'synchroFrequence': 'Fréquence de synchro',
    'resourceName': 'Nom',
    'chatName': 'Nom du chat',
    'tags': 'Mots clés',
    'createOption': 'Créer option "',
    'createChatConnectorOption': 'Créer un nouveau connecteur de messagerie instantanée "',
    'createFormConnectorOption': 'Créer un nouveau connecteur de stockage "',
    'searchConnector': 'Rechercher ou créer un nouveau connecteur ...',
    'sync': 'Synchroniser les mobiles',
  },
}
